import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import { MainContainer } from "./MailTokenTemplates.styled";
import {
  countryflagIcons as flagIcons,
  defaultCountryFlag,
} from "@utils/country-data";

const MailTokenTemplates = (props) => {
  const { t, data } = props;

  return (
    <MainContainer className="mailtoken-list__templates-container">
      {data?.templates && data.templates.length > 0 ? (
        data.templates.map((template, index) => (
          <div key={index} title={t(template.country?.name || "")}>
            {template.country?.id && (
              <Image
                src={
                  flagIcons[template.country.id]
                    ? flagIcons[template.country.id]
                    : defaultCountryFlag
                }
                alt={template.country.name}
                title={t(template.country.name)}
                className="mailtoken-list__flag-icon"
              />
            )}
          </div>
        ))
      ) : (
        <span>-</span>
      )}
    </MainContainer>
  );
};

MailTokenTemplates.propTypes = {
  data: PropTypes.shape({
    templates: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        description: PropTypes.string,
        country: PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
        }),
      })
    ),
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(MailTokenTemplates);
